import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "route-progress" }

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter()

/** 进度条数值（0~100） */
const progressValue = ref(0)

/** 进度条是否可见 */
const progressVisible = ref(false)

/** 进度条增长定时器句柄 */
let progressTimer: number | null = null

/** 进度条收尾延时句柄 */
let progressHideTimer: number | null = null

/**
 * 函数功能：启动路由进度条（从 8% 开始，逐步逼近 90% 模拟加载感）
 * 输入参数：无
 * 输出参数：无（更新 progressValue / progressVisible）
 * 返回值：void
 */
function startProgress(): void {
  if (progressHideTimer) {
    window.clearTimeout(progressHideTimer)
    progressHideTimer = null
  }
  if (progressTimer) window.clearInterval(progressTimer)
  progressVisible.value = true
  progressValue.value = 8
  progressTimer = window.setInterval(() => {
    // 越接近 90% 增长越慢，营造渐进加载效果
    progressValue.value = Math.min(90, progressValue.value + Math.max(1, (90 - progressValue.value) * 0.12))
  }, 120)
}

/**
 * 函数功能：完成路由进度条（冲到 100% 后淡出）
 * 输入参数：无
 * 输出参数：无（更新 progressValue / progressVisible）
 * 返回值：void
 */
function finishProgress(): void {
  if (progressTimer) {
    window.clearInterval(progressTimer)
    progressTimer = null
  }
  if (!progressVisible.value) return
  progressValue.value = 100
  progressHideTimer = window.setTimeout(() => {
    progressVisible.value = false
  }, 350)
}

// 路由钩子：切换开始启动进度条，切换完成（含懒加载解析）收尾
router.beforeEach(() => {
  startProgress()
})
router.afterEach(() => {
  finishProgress()
})

// 首次挂载确保进度条归零
onMounted(() => {
  progressVisible.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "page-fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "route-progress__bar",
        style: _normalizeStyle({ width: progressValue.value + '%' })
      }, null, 4)
    ], 512), [
      [_vShow, progressVisible.value]
    ])
  ], 64))
}
}

})